import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";

interface InternalLinkCardProps {
  title: string;
  description: string;
  href: string;
  badge?: string;
  keywords?: string[];
  className?: string;
}

export const InternalLinkCard: React.FC<InternalLinkCardProps> = ({
  title,
  description,
  href,
  badge,
  keywords = [],
  className = ""
}) => {
  return (
    <Card className={`group hover:shadow-md transition-shadow ${className}`}>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg group-hover:text-primary transition-colors">
            {title}
          </CardTitle>
          {badge && <Badge variant="secondary">{badge}</Badge>}
        </div>
        <CardDescription className="text-sm">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        {keywords.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-3">
            {keywords.slice(0, 3).map((keyword, idx) => (
              <Badge key={idx} variant="outline" className="text-xs">
                {keyword}
              </Badge>
            ))}
          </div>
        )}
        <Link 
          to={href}
          className="inline-flex items-center text-sm font-medium text-primary hover:underline"
          title={`Meer informatie over ${title}`}
        >
          Lees meer
          <ArrowRight className="ml-1 h-3 w-3" />
        </Link>
      </CardContent>
    </Card>
  );
};

export default InternalLinkCard;